var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStationsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2736 28.4219L55.7888 19.8495H52.8962L52.5926 17.2573H50.0562L49.4785 0H44.5259L43.9478 17.2573H41.4118L40.1034 28.4219H37.0983V22.0276H29.4343V27.5401L16.8363 21.619V27.5263L4.26733 21.619V28.4219H0V50H65V28.4219H61.2736Z",
    fill: "#F7931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2736 78.4219L90.7888 69.8495H87.8962L87.5926 67.2573H85.0562L84.4785 50H79.5259L78.9478 67.2573H76.4118L75.1034 78.4219H72.0983V72.0276H64.4343V77.5401L51.8363 71.619V77.5263L39.2673 71.619V78.4219H35V100H100V78.4219H96.2736Z",
    fill: "#F7931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.164 28.4081V22.0138H29.5V27.5263L16.902 21.6052V27.5125L4.33301 21.6052V28.4081H37.164Z",
    fill: "#29ABE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78.3943V75V72H64.336V77.5125L51.738 71.5914V77.4987L39.1692 71.5914V78.3943H72Z",
    fill: "#29ABE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationsIcon);
export default __webpack_public_path__ + "static/media/StationsIcon.2df738783b47900a9bf8c5a3bec2ff2b.svg";
export { ForwardRef as ReactComponent };